import styled from 'styled-components';

const Container = styled.button`
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 50%;

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
`;

export const Profile = () => (
  <Container type="button" className="bg-transparent border-0">
    <img
      src="https://i.pravatar.cc/300"
      alt="Usuario"
    />
  </Container>
);
